import type { Lang, ArticleContent, ArticleSection } from "@/mocks/articles-shared";
import { articlesEn } from "@/mocks/articles-en";
import { articlesPl } from "@/mocks/articles-pl";
import { articlesEs } from "@/mocks/articles-es";
import { articlesFr } from "@/mocks/articles-fr";

export type { Lang, ArticleContent, ArticleSection };

export const articles: Record<Lang, ArticleContent[]> = {
  en: articlesEn,
  pl: articlesPl,
  es: articlesEs,
  fr: articlesFr,
};